// extracted by mini-css-extract-plugin
export default {"backBtnWrap":"AcademicsStudent_backBtnWrap__PnygV","backIcon":"AcademicsStudent_backIcon__26yQH","screenTitle":"AcademicsStudent_screenTitle__OsYXm"};